export const ProductOptions = {
  All: 'All Products',
  None: 'No Products',
};

export default { ProductOptions };
